/**
 * Listado de formato de fechas.
 *
 * @readonly
 * @enum {string}
 */
const CONFIG_KEY = {
  DATOS_COMUNICACION: 'instance_complaint_form',
  TEMA: 'instance_theme',
  TEXTO: 'instance_text',
  LEGAL: 'instance_legaltext',
  POLITICA_SII: 'conditions',
  POLITICA_PRIV: 'privacy',
  POLITICA_COOKIES: 'cookies',
  MANUAL_USUARIOS: 'manual',
};

export default CONFIG_KEY;
